module.exports = __webpack_public_path__ + "img/product_71.b9815c8.webp";